import * as React from "react"
import { Grid, Box, Typography, Chip } from "@mui/material";
import { ModalSeeker } from "@ui-seeker/core";
import { IconSeeker } from "@ui-seeker/core";

import { ChipBlock, SitesChipBlock } from "../@components"
import {userDetailModalFilters} from "../../@signals";
import {isEmpty} from "@ui-seeker/utils";


export default function UserDetailModal() {
    return <ModalSeeker
        isOpen={!isEmpty(userDetailModalFilters.value)}
        controller={() => {
            userDetailModalFilters.value = {}
        }}
        size="md"
        hideActions
        title={'User Details ' + userDetailModalFilters.value.userName}
    >
        <Grid container spacing={3}>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        User Sites Scope:
                    </Typography>
                    <SitesChipBlock listElements={userDetailModalFilters.value.sitesScope} />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", fontSize: "0.8rem" }}>
                        Access:
                    </Typography>
                    {userDetailModalFilters.value.hasCustomModules
                        ? <Chip
                            icon={<IconSeeker icon="user-gear" sx={{ fontSize: '0.65rem !important', ml: '7px !important' }} />}
                            label="Customer Override"
                            size="small"
                            sx={{ height: 18, fontSize: '0.6rem', backgroundColor: 'secondary.main', color: 'secondary.contrastText' }}
                          />
                        : <Chip
                            icon={<IconSeeker icon="users" sx={{ fontSize: '0.65rem !important', ml: '7px !important' }} />}
                            label="customer default"
                            size="small"
                            variant="outlined"
                            sx={{ height: 18, fontSize: '0.6rem', color: 'info.main', borderColor: 'info.main', opacity: 0.8 }}
                          />
                    }
                </Box>
                <ChipBlock listElements={userDetailModalFilters.value.access} />
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Sku Groups:
                    </Typography>
                    <ChipBlock listElements={userDetailModalFilters.value.skuGroups} />
                </Box>
            </Grid>

        </Grid>
    </ModalSeeker>

}